import { BaseParameterDto } from '../../_models/base-parameter-dto';
import { Type } from 'class-transformer';

export class OwnerSearchResultDto extends BaseParameterDto {
    tollFreeNumber: string;
    managementCompany: string;
    location: string;
    community: string;
    owner: string;
    combinedOwner: string;
    currentOwner: boolean;
    propertyAddress: string;
    accountNumber: string;
    ownerOccupied: boolean;
    block: string;
    @Type(() => Date)
    buyerCloseDate: Date;
    cell: string;
    city: string;
    communityId: number;
    intacctCo: string;
    drvCollections: boolean;
    email1: string;
    email2: string;
    hasTenant: boolean;
    inBankruptcy: boolean;
    inForeclosure: boolean;
    inCollections: boolean;
    lot: string;
    lotType: string;
    mailingAddress: string;
    mailingAddress2: string;
    mailingCity: string;
    mailingCountry: string;
    mailingState: string;
    mailingZip: string;
    managementCompanyId: number;
    lastFirstName: string;
    ownerType: string;
    ownerId: number;
    phase: string;
    phone: string;
    priorId: string;
    propertyCSZ: string;
    propertyType: string;
    propertyId: number;
    section: string;
    state: string;
    streetName: string;
    streetNumber: string;
    zip: string;

    get openBalanceUrl(): string {
        return 'Open Balance';
    }
    get statementUrl(): string {
        return 'Statement';
    }
}
